"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disposeObjects = disposeObjects;
const log_node_1 = require("@video/log-node");
const context_1 = require("./context/context");
const vc_context_1 = require("./context/vc-context");
function disposeObjects(obj, innerDisposers, reason) {
    var _a;
    const object = obj.constructor;
    const className = (_a = object === null || object === void 0 ? void 0 : object.displayName) !== null && _a !== void 0 ? _a : object.name;
    if (obj.isDisposed) {
        return;
    }
    if ((0, vc_context_1.hasVcContext)(obj)) {
        obj.ctx.logger.trace(`dispose() ${reason}`, {
            aggregates: {
                reason,
            },
        });
        (0, context_1.cancel)(obj.ctx, `${className} disposed: ${reason}`);
    }
    innerDisposers.forEach((d) => {
        try {
            d(`${className} inner disposer: ${reason}`);
        }
        catch (err) {
            if ((0, vc_context_1.hasVcContext)(obj)) {
                obj.ctx.logger.error("error in dispose logic", {
                    object: (0, log_node_1.isSerializableObject)(obj) ? obj : `${obj}`,
                    className,
                    err: `${err}`,
                    reason,
                });
            }
        }
    });
    innerDisposers.splice(0, innerDisposers.length);
}
//# sourceMappingURL=dispose.js.map